<n-slide-window *ngIf="pageReady" [visible]="windowVisible" [width]="pageWidth" (onHide)="close()">
    <n-header>
        <h1>
            {{title}}
            <n-help-link [key]="helpLink" *ngIf="!isSimpleProtectionSupportSelectObj"></n-help-link>
            <n-help-link [key]="'simplifyprotectionCreate'" *ngIf="isSimpleProtectionSupportSelectObj"></n-help-link>
        </h1>
    </n-header>

    <!-- 极简模式，保护主页面，支持切换 -->
    <ng-container *ngIf="isSimpleProtectionSupportSelectObj">
        <div class="simple-step-title">
            <div class="step-number"><span>1</span></div>
            {{i18n.objectTypeLabel}}
        </div>

        <div class="protect-obj-type mb-16 ml-5" *ngIf="showLunObj && showFsObj">
            <!-- 保护LUN/FS切换按钮 -->
            <n-radio-group id="protect-radiogroup-id" [(ngModel)]="protectObjTypeValue" [buttonStyle]="true"
                class="mr-16">
                <n-radio id="protect-lun-radio-id" [value]="MO.LUN">
                    {{i18n.lunTitle}}
                </n-radio>
                <n-radio id="protect-fs-radio-id" [value]="MO.FILE_SYSTEM">
                    {{i18n.fsTitle}}
                </n-radio>
            </n-radio-group>
        </div>
    </ng-container>

    <!-- LUN场景 -->
    <app-create-lun-snapshot-form #lunForm *ngIf="protectObjTypeValue === MO.LUN" [fromPage]="fromPage"
        [selectType]="type" [inputLuns]="datas" [vstore]="vstore" [showSchedule]="showSchedule" [showSnap]="showSnap"
        [modifySchedule]="modifySchedule" (onClose)="onFormClose($event)">
    </app-create-lun-snapshot-form>

    <!-- FS场景 -->
    <app-create-fs-snap-form #fsForm *ngIf="protectObjTypeValue === MO.FILE_SYSTEM" [selectType]="type"
        [selectedFs]="selectedFs" [isCdp]="isCdp" [showSchedule]="showSchedule" [showSnap]="showSnap"
        [modifySchedule]="modifySchedule" (onClose)="onFormClose($event)">
    </app-create-fs-snap-form>

    <n-footer>
        <div class="slide-botton-group interval-20">
            <button nButton
                id="saveBtn"
                [theme]="'primary'"
                (click)="onOk()"
                [label]="i18n.okBtnLabel">
            </button>
            <button nButton
                id="cancelBtn"
                type="button"
                (click)="hide()"
                [label]="i18n.cancelBtnLabel">
            </button>
        </div>
    </n-footer>
</n-slide-window>
